"use client";

import { createContext } from "react";
import { iAgentSectionData } from "../content-blocks/agent-section";
import { iHolidayQuoteX } from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";
import { iOrganizationFooterConfig, iBrandQuoteLegalConfig } from "@/@sdk/brands/brand-model";
import type { ResolvedQuoteTheme } from "../quote-theme/quote-theme-types";

export interface BrandContextType {
  logo: {
    src: string;
    alt: string;
    width: number;
    height: number;
  };
  companyName: string;
  primaryColor: string;
  currentAgent?: iAgentSectionData;
  quotesDomain: string;
  quote: iHolidayQuoteX;
  quoteLegalConfig?: iBrandQuoteLegalConfig;
  isAdminMode?: boolean;
  footerConfig?: iOrganizationFooterConfig;
  headerTemplate: "Wide" | "Default";
  primaryColorFillMode: "Outline" | "Fill";
  navBarTemplate: "TYPE_1" | "TYPE_2";
  quoteTheme: ResolvedQuoteTheme;
}

export const HolidayQuoteBrandContext = createContext<
  BrandContextType | undefined
>(undefined);
